// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { AuditEventContextAction, CachedFile } from '@/audit/api/types';
import { AuditPropertyValue } from '@/audit/components/audit-property-value';
import { Stack, Typography } from '@mui/material';

interface Props {
  property: CachedFile;
  action: AuditEventContextAction;
}

export function AuditFileLabel(props: Props) {
  return (
    <Stack>
      <Typography display="flex" variant="caption" alignItems="center">
        <Typography component="span" variant="inherit" fontWeight="bold">
          {props.property.name}:&nbsp;
        </Typography>
        {props.action === 'CREATE' && (
          <AuditPropertyValue
            value={props.property.newValue?.filename ?? null}
          />
        )}
        {props.action === 'DELETE' && (
          <AuditPropertyValue
            value={props.property.oldValue?.filename ?? null}
          />
        )}
      </Typography>
    </Stack>
  );
}
